import { MapPin, Phone, ArrowDown } from "lucide-react";
import { INFO, IMAGES } from "@/lib/data";
import { MaskedLines, Reveal } from "./motion";
import { scrollToId } from "./SmoothScroll";

export default function Hero() {
  return (
    <section id="top" className="relative min-h-[100svh] overflow-hidden grain">
      {/* Ken-burns image */}
      <div className="absolute inset-0 hero-kenburns will-change-transform">
        <img
          src={IMAGES.terrace}
          alt="Dehors del Bar Ristorante Gabri a Lavagna al tramonto"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-charcoal/55 via-charcoal/35 to-charcoal/75" />
        <div className="absolute inset-0 bg-gradient-to-r from-charcoal/50 to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 min-h-[100svh] mx-auto max-w-[1400px] px-5 sm:px-8 flex flex-col justify-end pt-28 pb-20 sm:pb-28">
        <Reveal delay={0.3} y={0} className="flex items-center gap-3 mb-6">
          <span className="h-px w-10 bg-terracotta" />
          <span className="text-[11px] sm:text-xs tracking-[0.3em] uppercase text-bone/90 font-sans font-semibold">
            {INFO.city} · Riviera Ligure
          </span>
        </Reveal>

        <h1 className="text-bone font-serif font-light leading-[0.86] tracking-tight text-shadow-soft text-[3.4rem] sm:text-7xl lg:text-[8.5rem]">
          <MaskedLines mode="load" lines={["Il mare in", "tavola,"]} delay={0.4} />
          <MaskedLines
            mode="load"
            lines={["ogni giorno."]}
            delay={0.66}
            lineClassName="italic text-terracotta/95"
          />
        </h1>

        <Reveal delay={1.0} className="mt-7 max-w-md">
          <p className="text-bone/85 font-sans text-base sm:text-lg leading-relaxed">
            Bar, ristorante e gelateria nel cuore di Cavi di Lavagna: colazioni, aperitivi,
            gelati artigianali e cene di mare vista riviera.
          </p>
        </Reveal>

        <Reveal delay={1.2} className="mt-9 flex flex-col sm:flex-row gap-3 sm:items-center">
          <button
            onClick={() => scrollToId("prenota")}
            data-testid="hero-prenota-btn"
            className="group bg-terracotta hover:bg-terracotta-dark text-bone px-8 py-4 rounded-sm font-semibold tracking-wide transition-colors duration-300 flex items-center justify-center gap-2"
          >
            Prenota ora
          </button>
          <a
            href={`tel:${INFO.phoneTel}`}
            data-testid="hero-call-btn"
            className="group border border-bone/40 hover:border-bone text-bone px-8 py-4 rounded-sm font-medium tracking-wide transition-colors duration-300 flex items-center justify-center gap-2 backdrop-blur-sm"
          >
            <Phone size={17} /> Chiama ora
          </a>
          <a
            href={INFO.mapLink}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="hero-map-btn"
            className="text-bone/85 hover:text-white px-3 py-4 font-medium tracking-wide transition-colors duration-300 flex items-center justify-center gap-2"
          >
            <MapPin size={17} /> Apri la mappa
          </a>
        </Reveal>
      </div>

      <div className="absolute bottom-6 right-6 sm:right-10 z-10 text-bone/70 hidden sm:flex items-center gap-2 text-xs tracking-[0.2em] uppercase">
        <ArrowDown size={14} className="animate-bounce" /> Scorri
      </div>
    </section>
  );
}
